export default {
    day: '2023-10-23',
    content: {
        meta: [
            {
                type: 'info',
                text: '179'
            },
            {
                type: 'change',
                text: '180'
            },
            {
                type: 'change',
                text: '183'
            },
            {
                type: 'info',
                text: '184'
            },
            {
                type: 'clarity',
                text: '185'
            },
            {
                type: 'qol',
                text: '186'
            },
            {
                type: 'bugfix',
                text: '187'
            },
            {
                type: 'bugfix',
                text: '188'
            },
            {
                type: 'change',
                text: '196'
            },
            {
                type: 'qol',
                text: '200'
            },
            {
                type: 'qol',
                text: '222'
            },
            {
                type: 'new',
                text: '224'
            }
        ],
        mining: [
            {
                unlock: 'miningPickaxeCrafting',
                type: 'change',
                text: '181'
            },
            {
                type: 'qol',
                text: '190'
            },
            {
                unlock: 'miningPickaxeCrafting',
                type: 'clarity',
                text: '225'
            }
        ],
        note: [
            {
                type: 'change',
                text: '192'
            },
            {
                type: 'new',
                text: '193'
            }
        ],
        village: [
            {
                unlock: 'villageOffering1',
                type: 'clarity',
                text: '195'
            },
            {
                unlock: 'villageOffering1',
                type: 'clarity',
                text: '221'
            }
        ],
        achievement: [
            {
                unlock: 'hordeHeirlooms',
                type: 'balance',
                text: '204',
                balance: 'buff',
                before: '1000',
                after: '10.00K'
            }
        ],
        school: [
            {
                type: 'qol',
                text: '197'
            },
            {
                unlock: 'schoolArtSubfeature',
                type: 'bugfix',
                text: '198'
            },
            {
                type: 'balance',
                text: '199'
            }
        ],
        relic: [
            {
                type: 'clarity',
                text: '194'
            }
        ],
        horde: [
            {
                unlock: 'hordePrestige',
                type: 'change',
                text: '182'
            },
            {
                unlock: 'hordeEquipment',
                type: 'new',
                text: '189'
            },
            {
                unlock: 'hordeEquipment',
                type: 'new',
                text: 'addedHordeEquipment',
                params: [2]
            },
            {
                type: 'qol',
                text: '191'
            },
            {
                unlock: 'hordeHeirlooms',
                type: 'balance',
                text: '165',
                balance: 'nerf',
                before: '+0.8%',
                after: '+0.1%'
            },
            {
                unlock: 'hordeHeirlooms',
                type: 'balance',
                text: '201'
            },
            {
                unlock: 'hordePrestige',
                type: 'balance',
                text: '202'
            },
            {
                unlock: 'hordePrestige',
                type: 'balance',
                text: '203'
            },
            {
                type: 'balance',
                text: '205',
                balance: 'buff',
                before: '500.0K',
                after: '5.000M'
            },
            {
                unlock: 'hordeHeirlooms',
                type: 'balance',
                text: '206'
            },
            {
                unlock: 'hordeHeirlooms',
                type: 'balance',
                text: '207'
            },
            {
                type: 'balance',
                text: '208',
                balance: 'nerf',
                before: 'x1.15',
                after: 'x1.1'
            },
            {
                type: 'bugfix',
                text: '209'
            },
            {
                unlock: 'hordeEquipment',
                type: 'bugfix',
                text: '214'
            }
        ],
        farm: [
            {
                type: 'clarity',
                text: '211'
            },
            {
                type: 'balance',
                text: '215',
                balance: 'nerf',
                before: '1%',
                after: '0.4%'
            },
            {
                type: 'balance',
                text: '216'
            },
            {
                unlock: 'farmCropExp',
                type: 'balance',
                text: '217',
                balance: 'nerf',
                before: 'x0.8',
                after: 'x0.92'
            },
            {
                unlock: 'farmCropExp',
                type: 'balance',
                text: '218',
                balance: 'buff',
                before: 'x1.15',
                after: 'x1.25'
            },
            {
                unlock: 'farmCropExp',
                type: 'balance',
                text: '219',
                balance: 'buff',
                before: 'x1.12',
                after: 'x1.35'
            },
            {
                unlock: 'farmCropExp',
                type: 'balance',
                text: '220',
                balance: 'buff',
                before: 'x1.2',
                after: 'x1.3'
            },
            {
                unlock: 'farmCropExp',
                type: 'balance',
                text: '223',
                balance: 'nerf',
                before: '+0.5',
                after: '+0.35'
            }
        ],
        event: [
            {
                type: 'bugfix',
                text: '212'
            },
            {
                type: 'change',
                text: '213'
            }
        ],
        treasure: [
            {
                type: 'qol',
                text: '210'
            }
        ]
    }
}
